module.exports = __webpack_public_path__ + "static/media/uk.386cc387.svg";